/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-deprecated */
import React, { Component } from 'react'
import { Dropdown } from 'antd'
import moment from 'moment'
import classnames from 'classnames'
import isEqual from 'lodash/isEqual'
import DateRange from './dateRange'
import Icon from '../../icon'
import defaultRanges from './ranges'
import Mini from './mini'
import MonthAndWeek from './monthAndWeek'
import Day from './day'
import userInfo from '../../../common/userInfo'
import DropDownClearIcon from '../../../baseComponent/dropDownClearIcon'
import './index.less'

const FORMAT = 'YYYY-MM-DD'
const ONE_STEP_TYPE = {
  NEXT: 'next',
  PREV: 'prev'
}
const DISPLAY_TYPES = {
  MINI: 'mini',
  WEEK: 'week',
  MONTH: 'month',
  DEFAULT: 'default',
  DAY: 'day'
}
const STYLE_TYPE = {
  BUTTON: 'button',
  TEXT: 'text',
}
function convertToString(moments) {
  return moments.map(m => m.format(FORMAT))
}
const getDefaultEarliestDate = () => {
  const defaultYearDate = moment().subtract(2, 'y')
  return defaultYearDate.subtract(1, 'quarter').startOf('quarter').format(FORMAT)
}
class _DatePicker extends Component {
  static LAST_WEEK = convertToString(defaultRanges[8].value)

  static LAST_MONTH = convertToString(defaultRanges[9].value)

  static YESTERDAY = convertToString(defaultRanges[0].value)

  static LAST_7_DAY = convertToString(defaultRanges[1].value)

  static LAST_15_DAY = convertToString(defaultRanges[2].value)

  static LAST_30_DAY = convertToString(defaultRanges[3].value)

  static LAST_3_MONTH = convertToString(defaultRanges[6].value)

  static LAST_1_YEAR = convertToString(defaultRanges[7].value)

  static ALL = convertToString(defaultRanges[10].value)

  static DISPLAY_TYPES = DISPLAY_TYPES

  static TYPE = STYLE_TYPE

  static defaultProps = {
    defaultValue: _DatePicker.YESTERDAY,
    value: [],
    noneText: null,
    allowClear: false,
    ranges: defaultRanges.filter(m => m.show),
    displayType: DISPLAY_TYPES.DEFAULT,
    type: STYLE_TYPE.TEXT,
    showPrevNext: false,
    tipDates: [],
    icon: <Icon type="m-Vxing_xia" style={{ color: '#C8C9D7', fontSize: '16px' }} />,
    iconUp: <Icon type="m-Vxing_shang" style={{ color: '#C8C9D7', fontSize: '16px' }} />,
    title: '',
    earlistDate: getDefaultEarliestDate(),
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onChange() { },
    checkAuth: true,
    textSize: '',
    selectedColor: '',
    disabled: false,
    readonly: false,
  }

  state = {
    visible: false,
    value: this.props.value && this.props.value.length > 0
      ? this.props.value : this.props.defaultValue,
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.value, this.props.value)) {
      this.setState({ value: nextProps.value })
    }
  }

  onClear(e) {
    e.stopPropagation()
    this.onChange([])
  }

  onChange(value,) {
    this.setState({
      visible: false,
      value,
    }, () => {
      this.props.onChange(value)
    })
  }

  getShowText() {
    const { ranges, noneText, hiddenValue, showTime = false } = this.props
    const { value } = this.state
    if (hiddenValue) {
      return noneText || '全部'
    }
    if (value.length === 2 && value[0] && value[1]) {
      const sameRanges = ranges.filter((m) => {
        const val1 = m.value
        return val1[0]?.isSame(moment(value[0], FORMAT), 'd') && val1[1]?.isSame(moment(value[1], FORMAT), 'd') && m.show
      })
      if (sameRanges.length > 0) {
        return sameRanges[0].name
      }
      if (value[0] === value[1]) {
        return !showTime ? value[0] : `${moment(value[0]).format('YYYY-MM-DD HH:mm:ss')} ~ ${moment(value[0]).add(1, 'days').add(-1, 'second').format('YYYY-MM-DD HH:mm:ss')}`
      }
      return !showTime ? `${value[0]} ~ ${value[1]}` : `${moment(value[0]).format('YYYY-MM-DD HH:mm:ss')} ~ ${moment(value[1]).add(1, 'days').add(-1, 'second').format('YYYY-MM-DD HH:mm:ss')}`
    }
    return noneText || '全部'
  }

  handleVisibleChange = (visible) => {
    this.props.handleVisibleChange && this.props.handleVisibleChange(visible)
    this.setState({ visible })
  }

  stepOneDay(type = ONE_STEP_TYPE.NEXT) {
    const [start, end] = this.state.value
    const n = type === ONE_STEP_TYPE.NEXT ? 1 : -1
    if (start && end && Math.abs(moment(start).diff(moment(end), 'days')) <= 1) {
      this.setState({
        value: [
          moment(start).add(n, 'day').format(FORMAT),
          moment(end).add(n, 'day').format(FORMAT),
        ]
      }, () => this.onChange(this.state.value))
    }
  }

  nextDay() {
    this.stepOneDay(ONE_STEP_TYPE.NEXT)
  }

  prevDay() {
    this.stepOneDay(ONE_STEP_TYPE.PREV)
  }

  canUse(type = ONE_STEP_TYPE.NEXT) {
    const [start, end] = this.state.value
    const { earlistDate } = this.props
    if (start && end && Math.abs(moment(start).diff(moment(end), 'days')) === 0) {
      if (type === ONE_STEP_TYPE.NEXT) {
        return moment(end).add(1, 'day').isBefore(moment().startOf('day'))
      }
      let before = moment(earlistDate, FORMAT)
      const begin = moment().subtract(1, 'd').endOf('day')
      if (userInfo.userAuthCodeList.some(m => m === 'history_no_limit')) {
        before = moment(earlistDate, FORMAT)
      } else if (userInfo.userAuthCodeList.some(m => m === 'history_two_year')) {
        before = moment.max(before, begin.subtract(2, 'year').subtract(1, 'quarter').startOf('quarter'))
      } else if (userInfo.userAuthCodeList.some(m => m === 'history_one_year')) {
        before = moment.max(before, begin.subtract(1, 'year').subtract(1, 'quarter').startOf('quarter'))
      } else if (userInfo.userAuthCodeList.some(m => m === 'history_six_month')) {
        before = moment.max(before, begin.subtract(6, 'month').subtract(1, 'quarter').startOf('quarter'))
      }
      return before.isBefore(end)
    }
    return false
  }

  renderContent() {
    const { visible } = this.state
    const { noneText, iconUp, icon, className, style, textSize, textStyle = null, iconShowType, iconTransition } = this.props
    const text = this.getShowText()
    const classname = classnames('date-picker-display-text', 'dropDownClearIcon', { clear: this.props.allowClear }, className)
    if (text !== (noneText || '全部')) {
      return <a className={classname} style={style}>
        <DropDownClearIcon visible={visible} onClear={this.onClear.bind(this)}>
          <div className="mn-date-picker-display-text-1" style={{ fontSize: textSize, ...textStyle }}>{text}</div>
        </DropDownClearIcon>
      </a>
    }
    return (
      <a
        className={classname}
        style={style}
      >
        <Icon type="m-Vxing_xia" style={{ marginRight: '4px', color: '#2f54eb', fontSize: '16px', display: this.props.hideIcon ? 'none' : 'inline-block' }} />
        <span style={{ fontSize: textSize, ...textStyle }}>{text}</span>
        {iconShowType ? iconTransition(visible) : (visible ? iconUp : icon)}
      </a>
    )
  }

  renderPre() {
    const { showPrevNext } = this.props
    if (!showPrevNext) return null

    return (
      <span>
        <a
          onClick={this.canUse(ONE_STEP_TYPE.PREV) && this.prevDay.bind(this)}
          className={classnames({
            'date-picker-one': true,
            disabled: !this.canUse(ONE_STEP_TYPE.PREV)
          })}
        >
          <Icon type="m-Vxing_zuo" />
        </a>
      </span>
    )
  }

  renderNext() {
    const { showPrevNext } = this.props
    if (!showPrevNext) return null
    return (
      <span>
        <a
          onClick={this.canUse(ONE_STEP_TYPE.NEXT) && this.nextDay.bind(this)}
          className={classnames({
            'date-picker-one': true,
            'date-picker-right': true,
            disabled: !this.canUse(ONE_STEP_TYPE.NEXT),
          })}
        ><Icon type="m-Vxing_you" />
        </a>
      </span>
    )
  }

  renderOverlay() {
    const { value } = this.state
    const { ranges, earlistDate } = this.props
    switch (this.props.displayType) {
      case DISPLAY_TYPES.MINI:
        return <Mini {...this.props} value={value} onChange={this.onChange.bind(this)} />
      case DISPLAY_TYPES.MONTH:
        return <MonthAndWeek {...this.props} value={value} type="month" onChange={this.onChange.bind(this)} />
      case DISPLAY_TYPES.WEEK:
        return <MonthAndWeek {...this.props} value={value} type="week" onChange={this.onChange.bind(this)} />
      case DISPLAY_TYPES.DAY:
        return <Day
          {...this.props}
          accountInfo={userInfo}
          earlistDate={earlistDate}
          value={value}
          onChange={this.onChange.bind(this)}
        />
      default:
        return (<DateRange
          {...this.props}
          visible
          ranges={ranges}
          value={value}
          format={FORMAT}
          onChange={this.onChange.bind(this)}
        />)
    }
  }

  render() {
    const { visible, } = this.state
    const { type, disabled, wrapperClassName, wrapperStyle, overlayClassName, getPopupContainer, overlayStyle, placement, trigger = ['click'] } = this.props
    const isTextStyle = type === STYLE_TYPE.TEXT
    const isButtonStyle = type === STYLE_TYPE.BUTTON
    return (
      <span className={classnames('zy-date-picker', wrapperClassName)} style={wrapperStyle}>
        {this.props.title && <span className="title">{this.props.title}</span>}
        <span className={classnames('mn-date-picker-dropdown', { 'mn-date-range-type-text': isTextStyle, disabled, 'date-range-type-button': isButtonStyle })}>
          {this.renderPre()}
          <Dropdown
            placement={placement || 'bottomRight'}
            style={{ zIndex: 1000 }}
            visible={visible}
            overlayStyle={{ zIndex: 1500, ...overlayStyle }}
            overlayClassName={overlayClassName}
            overlay={() => this.renderOverlay()}
            onVisibleChange={this.handleVisibleChange}
            disabled={disabled}
            trigger={trigger}
            getPopupContainer={getPopupContainer}
          >
            {this.renderContent()}
          </Dropdown>
          {this.renderNext()}
        </span>
      </span>
    )
  }
}
// function mapStateToProps({ account: { accountInfo, } }) {
//   return {
//     accountInfo
//   }
// }
/**
 * @type {_DatePicker}
 */
const DatePicker = _DatePicker
const btns = [
  { value: _DatePicker.YESTERDAY, dateRange: 1, label: '昨日', key: 1 },
  { value: _DatePicker.LAST_7_DAY, dateRange: 2, label: '近7日', key: 7 },
  { value: _DatePicker.LAST_30_DAY, dateRange: 3, label: '近30日', key: 30 },
  { value: _DatePicker.LAST_3_MONTH, dateRange: 4, label: '近3月', key: 3 }
]
DatePicker.ButtonGroup = ({ mode = [1, 7, 30], onChange, canCustomized, ...otherProps }) => {
  return <span className="mn-date-picker-group">
    {btns.filter(m => mode.some(k => m.key === k)).map(m => <a onClick={() => onChange(m.value, m)} className={classnames('mn-date-picker-group-item', { active: isEqual(otherProps.value, m.value) })}>{m.label}</a>)}
    {canCustomized && <DatePicker type="button" onChange={onChange} {...otherProps} />}
  </span>
}

export default DatePicker
